import { commonRules, RuleType } from 'helpers/form-validations';

export const validationRules = {
  companyName: [
    commonRules.required,
    { type: RuleType.MaxLength, value: 40, message: 'Must be not more than 40 character' },
  ],
};
